import {
  format,
  isFuture as isDateFnsFuture,
  parseISO,
  startOfToday,
} from "date-fns";
import { differenceInDays, isAfter, startOfDay } from "date-fns";

export const formatDate = (date, pattern = "dd/MM/yyyy") => {
  if (date instanceof Date) return format(date, pattern);
  if (typeof date === "string") return format(parseISO(date), pattern);

  return "";
};

export const isFuture = (date) => {
  if (date instanceof Date) return isDateFnsFuture(date);
  if (typeof date === "string") return isDateFnsFuture(parseISO(date));

  return false;
};

export function calculateRemainingDays(endDate) {
  if (!endDate) return 0;

  const today = startOfToday();
  const end = startOfDay(parseISO(endDate));

  if (!isAfter(end, today)) return 0;

  return differenceInDays(end, today) + 1; // +1 to include the last day
}

export function calculateDaysBetweenDates(startDate, endDate) {
  if (!startDate || !endDate) return 0;

  const start = startOfDay(parseISO(startDate));
  const end = startOfDay(parseISO(endDate));

  return differenceInDays(end, start) + 1; // +1 to include the last day
}
